import { Vue, Options } from 'vue-class-component';
import { PropType } from 'vue';

import {
  PlantSharingDTO,
  UserDTO,
} from '@/../client-generator/generated-clients/plants';
import { getUserInitialsForBubble } from '@/core/utils/utils';
import { mapState } from 'vuex';
import { AccountInfo } from '@azure/msal-browser';

@Options({
  name: 'UserItem',
  props: {
    user: {
      required: true,
      type: Object as PropType<PlantSharingDTO | UserDTO>,
    },
    isOwner: {
      type: Boolean,
    },
    isMeTheOwner: {
      type: Boolean,
    },
  },
  emits: ['delete-user', 'transfer-ownership'],
  computed: {
    ...mapState(['account']),
  },
})
export default class UserItem extends Vue {
  user!: PlantSharingDTO | UserDTO;
  isOwner!: boolean;
  isMeTheOwner!: boolean;
  account!: AccountInfo;

  get isUserMe() {
    return (
      ((this.user as PlantSharingDTO).userId || (this.user as UserDTO).id) ===
      this.account.localAccountId
    );
  }

  get isConfirmed() {
    if ('confirmed' in this.user) {
      return !!this.user.confirmed;
    }
    return false;
  }

  get userInitials() {
    return getUserInitialsForBubble(this.user);
  }

  get userDisplayName() {
    let displayName = '';

    if (this.user.name) {
      displayName += this.user.name;
    }

    if (this.user.surname) {
      displayName += ` ${this.user.surname}`;
    }

    return displayName;
  }

  handleDeleteSharingUser() {
    this.$emit('delete-user', this.user);
  }

  handleTransferOwnership() {
    this.$emit('transfer-ownership', this.user);
  }
}
